import { useState } from 'react';
import '../../styles/navbar.css';
import srkLogo from '../../assets/images/logo/srk_logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="rt-header sticky-top">
      {/* <div className="rt-ticker" role="marquee" aria-label="Announcement">
        <div className="rt-ticker-track">
          <span className="rt-ticker-item">Welcome to SRK Production</span>
          <span className="rt-ticker-item">Welcome to SRK Production</span>
          <span className="rt-ticker-item">Welcome to SRK Production</span>
          <span className="rt-ticker-item">Welcome to SRK Production</span>
        </div>
      </div> */}
      <nav className="navbar navbar-expand-lg navbar-dark rt-navbar">
      <div className="container-fluid px-4">
        {/* Logo */}
        <a className="" href="/">
          <img src={srkLogo} alt="SRK Logo" height="60" />
        </a>

        {/* Hamburger Button */}
        <button 
          className="navbar-toggler border-0" 
          type="button" 
          onClick={toggleMenu}
          aria-controls="navbarNav" 
          aria-expanded={isOpen}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Menu */}
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto gap-4">
            <li className="nav-item">
              <a className="nav-link" href="/events" onClick={() => setIsOpen(false)}>
                Events
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/about" onClick={() => setIsOpen(false)}>
                About
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/contact" onClick={() => setIsOpen(false)}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
      </nav>
    </div>
  );
};

export default Navbar;
